// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import service from './utils/request.js'
import U from './utils/baseutil.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css'
import './assets/css/index.scss'
import audio from "vue-mobile-audio";
import VueTouch from 'vue-touch'
import { Loading } from 'vant';
import VueCookies from 'vue-cookies'

Vue.use(Loading);
Vue.use(audio);

Vue.use(Vant);
Vue.use(VueTouch, {name: 'v-touch'})

Vue.prototype.$ajax=service;
Vue.prototype.U=U;

Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.use(VueCookies)

import moment from 'moment'

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dataStr).format(pattern)

})

Vue.prototype.$moment=moment

let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
Vue.prototype.$isios=isiOS;
import mtabbar from './components/common/Tabbar.vue'
Vue.component('mtabbar',mtabbar);
/* eslint-disable no-new */

import jtp from './utils/jstoapp.js'
Vue.prototype.$jtp=jtp;

Vue.prototype.getViewportSize = function(){
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
  };
};

import global from '../static/gloabvar.js'
Vue.prototype.$global=global;
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js